<template>
    <div v-if="userStore.user.letter_count" class="col-lg-5 col-md-12 col-12" id="disputes_step">
        <div class="card card-statistics" :class="{ 'border-primary border-darken-1': $route.name == 'report' }">
            <div class="card-header mx-auto">
                <h3 class="card-title text-primary">Dispute Letters</h3>
            </div>
            <div class="card-body statistics-body">
                <div class="row">
                    <div class="col-lg-3 col-12 mx-auto">
                        <div class="media">
                            <div class="avatar bg-light-primary mr-1">
                                <div class="avatar-content">
                                    <vue-feather type="file-text" class="avatar-icon" />
                                </div>
                            </div>
                            <div class="media-body">
                                <h2 class="text-bold-700 mb-0">
                                    {{ userStore.user.letter_count.total > 0 ? userStore.user.letter_count.total : 0 }}
                                </h2>
                                <p class="card-text font-small-2 mb-0">Total Letters</p>
                            </div>
                        </div>
                    </div>
                    <div class="col-lg-3 col-12 mx-auto">
                        <div class="media">
                            <div class="avatar bg-light-info mr-1">
                                <div class="avatar-content">
                                    <vue-feather type="file-minus" class="avatar-icon" />
                                </div>
                            </div>
                            <div class="media-body">
                               <div id="total_pending">
                                    <h2 class="text-bold-700 mb-0">
                                        {{ userStore.user.letter_count.pending_count > 0 ? userStore.user.letter_count.pending_count : 0 }}
                                    </h2>
                               </div>
                                <p class="card-text font-small-2 mb-0">Pending Letters</p>
                            </div>
                        </div>
                    </div>
                    <div class="col-lg-3 col-12 mx-auto">
                        <div class="media">
                            <div class="avatar bg-light-danger mr-1">
                                <div class="avatar-content">
                                    <vue-feather type="trash-2" class="avatar-icon" />
                                </div>
                            </div>
                            <div class="media-body">
                                <div id="total_removed">
                                    <h2 class="text-bold-700 mb-0">
                                        {{ userStore.user.letter_count.removed_count > 0 ? userStore.user.letter_count.removed_count : 0 }}
                                    </h2>
                                </div>
                                <p class="card-text font-small-2 mb-0">Deleted Letters</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import { useUserStore } from '../../stores/UserStore.js'
export default{
    setup(){
        return {
            userStore:useUserStore()
        }
    },
    methods:{}
}
</script>
